// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__ia64A","search":"Settings_search__2VQZW","filter":"Settings_filter__3fgjd"};